import moment from "moment"
const NICE_INTERVALS = [
  // Milliseconds
  0.01,                       // 10ms
  0.02,                       // 20ms
  0.05,                       // 50ms
  0.1,                        // 100ms
  0.2,                        // 200ms
  0.5,                        // 500ms
  // Seconds
  1,                          // 1s
  2,                          // 2s
  5,                          // 5s
  10,                         // 10s
  15,                         // 15s
  30,                         // 30s
  // Minutes
  60,                         // 1m
  120,                        // 2m
  300,                        // 5m
  600,                        // 10m
  900,                        // 15m
  1800,                       // 30m
  // Hours
  3600,                       // 1h
  7200,                       // 2h
  10800,                      // 3h
  21600,                      // 6h
  43200,                      // 12h
  // Days
  86400,                      // 1d
  172800,                     // 2d
  604800,                     // 7d
  1209600,                    // 14d
  // Months
  2592000,                    // 30d
  // Years
  31536000,                   // 1y
];

export function getStartAndEndTime(options){
  const { duration, start, end, chart_width } = options
  const response = {
    start: null,
    end: null,
    step: null
  }
  const now = moment()
  switch (duration) {
    case 'last_min':
      response.start=moment.utc(now).subtract(1,'minutes')
      response.end=moment.utc(now)
      break;
    case 'last_30_min':
      response.start=moment.utc(now).subtract(30,'minutes')
      response.end=moment.utc(now)
      break;
    case 'last_hour':
      response.start=moment.utc(now).subtract(1,'hours')
      response.end=moment.utc(now)
      break;
    case 'last_2_hour':
      response.start=moment.utc(now).subtract(1,'hours')
      response.end=moment.utc(now)
      break;
    case 'today':
      response.start=moment.utc(now).startOf('day')
      response.end=moment.utc(now).endOf('day')
      break;
    case 'yesterday':
      response.start=moment.utc(now).subtract(1,'day').startOf('day')
      response.end=moment.utc(now).subtract(1,'day').endOf('day')
      break;
    case 'this_week':
      response.start=moment.utc(now).startOf('week')
      response.end=moment.utc(now).endOf('week')
      break;
    case 'last_week':
      response.start=moment.utc(now).subtract(1,'weeks').startOf('week')
      response.end=moment.utc(now).subtract(1,'weeks').endOf('week')
      break;
    case 'this_month':
      response.start=moment.utc(now).startOf('month')
      response.end=moment.utc(now).endOf('month')
      break;
    case 'last_month':
      response.start=moment.utc(now).subtract(1,'month').startOf('month')
      response.end=moment.utc(now).subtract(1,'month').endOf('month')
      break;
    case 'last_2_month':
      response.start=moment.utc(now).subtract(1,'month').startOf('month')
      response.end=moment.utc(now).endOf('month')
      break;
    case 'last_3_month':
      response.start=moment.utc(now).subtract(2,'month').startOf('month')
      response.end=moment.utc(now).endOf('month')
      break;
    case 'this_year':
      response.start=moment.utc(now).startOf('year')
      response.end=moment.utc(now).endOf('year')
      break;
    case 'last_year':
      response.start=moment.utc(now).subtract(1,'year').startOf('year')
      response.end=moment.utc(now).subtract(1,'year').endOf('year')
      break;
    case 'last_2_year':
      response.start=moment.utc(now).subtract(1,'year').startOf('year')
      response.end=moment.utc(now).endOf('year')
      break;
    case 'last_3_year':
      response.start=moment.utc(now).subtract(2,'year').startOf('year')
      response.end=moment.utc(now).endOf('year')
      break;
    default:
      response.start=moment.utc(start)
      response.end=moment.utc(end)
      break;
  }
  const maxDataPoints = chart_width && chart_width > 0 ? chart_width : 1000
  const durationInSeconds = response.end.diff(response.start,'seconds');
  const rawIntervalInSeconds = durationInSeconds / maxDataPoints;
  for (const interval of NICE_INTERVALS) {
    if (rawIntervalInSeconds <= interval) {
      response.step=interval;
      break;
    }
  }
  if(!response.step) response.step=NICE_INTERVALS[NICE_INTERVALS.length - 1]
  return response;
}